<template>
	<section style="height: 100%;">
		<div class="col" style="height: 100%;">
			<div class="row" style="height: 100%;">
				<div class="col-lg-5" v-show="step == 1">
					<ValidationObserver tag="form" v-slot="{ invalid }" class="mx-auto col-lg-10">
						<router-link to="/"><i class="fa fa-arrow-left" style="margin-top: 50px;"></i></router-link>
						<h4 class="mb-4 mt-4"><b>Daftar</b></h4>
						<img src="/img/register-step-1-new.png" alt="" class="mb-4">

						<ValidationProvider name="Nama" rules="required">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Nama</label>
								<input type="text" v-model="model.name" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan Nama">
								<div class="f-12 text-danger">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>

						<ValidationProvider name="Nama Perusahaan" rules="required">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Nama Perusahaan</label>
								<input type="text" v-model="model.corporate_name" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan Nama Perusahaan">
								<div class="f-12 text-danger">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>

						<ValidationProvider name="Nomor Telepon" rules="required|numeric|min:8">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Nomor Telepon</label>
								<input type="number" v-model="model.phone_number" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan Nomor Telepon">
								<div class="f-12 text-danger">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>
						<button :disabled="invalid" @click="step = 2" type="button" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Selanjutnya</button>
					</ValidationObserver>
				</div>
				<div class="col-lg-5" v-show="step == 2">
					<ValidationObserver tag="form" v-slot="{ invalid }" class="mx-auto col-lg-10">
						<router-link to="/"><i class="fa fa-arrow-left" style="margin-top: 50px;"></i></router-link>
						<h4 class="mb-4 mt-4"><b>Daftar</b></h4>
						<img src="/img/register-step-2-new.png" alt="" class="mb-4">

						<div class="alert-danger p-1 mb-2 text-center" style="border: 1px solid #FF9D9D; border-radius: 4px;" v-if="errors">
							<div v-for="(v, k) in errors" :key="k">
								<p v-for="error in v" :key="error" class="mb-0 f-14 text-danger" v-html="error"></p>
							</div>
						</div>

						<ValidationProvider name="Email" rules="required|email">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Email</label>
								<input type="email" v-model="model.email" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan email">
								<div class="f-12 text-danger">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>

						<ValidationProvider name="Kata Sandi" rules="required|min:8|alpha_num">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Kata Sandi</label>
								<div class="input-group" :class="{ 'error': errors[0] }" id="show_hide_password">
									<input type="password" v-model="model.password" class="form-control append-button" placeholder="Masukkan kata sandi">
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="fa fa-eye-slash" aria-hidden="true"></i>
										</span>
									</div>
								</div>
								<div class="f-12 text-danger mt-2">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>
						<ValidationProvider name="Konfirmasi Kata Sandi" rules="required|confirmed:Kata Sandi">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label f-14">Konfirmasi Kata Sandi</label>
								<div class="input-group" :class="{ 'error': errors[0] }" id="show_hide_password2">
									<input type="password" v-model="model.confirm_password" class="form-control append-button" placeholder="Konfirmasi kata sandi">
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="fa fa-eye-slash" aria-hidden="true"></i>
										</span>
									</div>
								</div>
								<div class="f-12 text-danger mt-2">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>
						<div class="row">
							<div class="col-6"><button type="button" @click="step = 1" class="btn btn-outline-primary w-100 f-14 pd-10-20 mt-3">Kembali</button></div>
							<div class="col-6"><button type="button" :disabled="invalid" @click="register()" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Daftar</button></div>
						</div>
					</ValidationObserver>
				</div>
				<div class="col-lg-5" v-show="step == 3">
					<ValidationObserver tag="form" class="mx-auto col-lg-10">
						<router-link to="/"><i class="fa fa-arrow-left" style="margin-top: 50px;"></i></router-link>
						<h4 class="mb-4 mt-4"><b>Daftar</b></h4>
						<img src="/img/register-step-3-new.png" alt="" class="mb-4">

						<p class="f-14 text-secondary">Terima kasih sudah mendaftar. <br>Silakan cek email anda untuk melakukan verifikasi</p>
						<button @click="$router.push('/')" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Masuk</button>
					</ValidationObserver>
				</div>
				<div class="d-none d-lg-block col-7"
					style="
						background-image: url('/img/login.png');
						background-color: #FFA827;
						background-repeat: round;
						height: 100%;
					">
					<div class="vertical-center" style="top:50%;">
						<img src="/img/login-1.png" alt="">
						<p class="text-white">Check every shipment easily</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import $ from 'jquery'
export default {
	data() {
		return {
			model: {
				name: '',
				corporate_name: '',
				phone_number: '',
				email: '',
				password: '',
				confirm_password: '',
				role: 4
			},
			step: 1,
			errors: null
		}
	},
	methods: {
		register() {
			let _ = this
			_.axios.post('/customer/registration', _.model)
				.then(resp => {
					console.log(resp.data)
					_.step = 3
				})
				.catch(err => {
					_.errors = err.response.data.message
				})	
		}
	},
	mounted() {
		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
		});

		$("#show_hide_password2 span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password2 input').attr("type") == "text"){
	            $('#show_hide_password2 input').attr('type', 'password');
	            $('#show_hide_password2 i').addClass( "fa-eye-slash" );
	            $('#show_hide_password2 i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password2 input').attr("type") == "password"){
	            $('#show_hide_password2 input').attr('type', 'text');
	            $('#show_hide_password2 i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password2 i').addClass( "fa-eye" );
	        }
		});
	}
}
</script>